import { Formik } from "formik";
import React, { useEffect } from "react";
import { Form, Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Mixpanel from "mixpanel-browser";

import {
  getParticularProject,
  resetParticularProjectData,
} from "../../../features/projectManagement/getParticularProject";
import Button from "../../form-components/Button";
import Fields from "../../form-components/Fields";
import closeCircle from "../../../assets/images/close-circle.svg";
import uploadIcn from "../../../assets/images/upload-icon.svg";
import Input from "../../form-components/Input";
import { editProject } from "../../../features/projectManagement/editProjectSlice";
import { OK } from "../../../constants/statusCode";
// import { showSuccess } from "../../../utils/messageHelper";
import Yup from "../../../validations/validationsLib";
import { getProjectList } from "../../../features/projectManagement/getProjectListSlice";
import Loader from "../../../common/loader/Loader";
import { getSwitchProjectList } from "../../../features/projectManagement/switchProjectSlice";

const EditProjectModal = ({
  isVisible,
  toggleFunction,
  projectId,
  isFromHeader = false,
}) => {
  const { projectData, projectDataLoading, editProjectLoading } = useSelector(
    (state) => ({
      projectData: state?.getParticularProjectReducer?.responseData,
      projectDataLoading: state?.getParticularProjectReducer?.isLoading,
      editProjectLoading: state?.editProjectReducer?.isLoading,
    })
  );

  let localStorageProjectData = JSON.parse(localStorage.getItem("_user"));

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getParticularProject(projectId));
  }, []);

  const handleEditProject = async (values) => {
    let formData = new FormData();
    formData.append("name", values?.name);
    formData.append("website_url", values?.websute_url);
    formData.append(
      "original_file_name",
      localStorageProjectData?.projects[0].website_logo
    );
    formData.append("website_logo", values?.site_logo);
    /* formData.append("website_favicon", values?.fav_icon); */
    formData.append("is_default", values?.is_default === true ? 1 : 0);
    Mixpanel.track("Edit project Button Clicked", {
      Page: "Edit Project Modal",
    });
    const { payload } = await dispatch(
      editProject({ projectId, _data: formData })
    );
    if (payload.status === OK) {
      // showSuccess(payload?.data?.responseMessage);
      if (isFromHeader) {
        localStorageProjectData.projects[0].uuid = projectData?.uuid;
        localStorageProjectData.projects[0].name = values?.name;
        localStorageProjectData.projects[0].slug = projectData?.slug;
        localStorageProjectData.projects[0].website_logo =
          payload?.data?.responseData?.project?.website_logo;
        localStorage.setItem("_user", JSON.stringify(localStorageProjectData));
      } else {
        if (projectId === localStorageProjectData?.projects[0].uuid) {
          localStorageProjectData.projects[0].uuid = projectData?.uuid;
          localStorageProjectData.projects[0].name = values?.name;
          localStorageProjectData.projects[0].slug = projectData?.slug;
          localStorageProjectData.projects[0].website_logo =
            payload?.data?.responseData?.project?.website_logo;
          localStorage.setItem("_user", JSON.stringify(localStorageProjectData));
        }
      }
      toggleFunction();
      await dispatch(resetParticularProjectData());
      await dispatch(getProjectList({ perPage: 10, page: 1 }));
      await dispatch(getSwitchProjectList({ search: "" }));
    }
  };

  const convertFileObjectToObjectURL = (_obj) => {
    var objectUrl = URL.createObjectURL(_obj);
    return objectUrl;
  };

  return (
    <>
      {projectDataLoading || editProjectLoading ? (
        <Loader />
      ) : (
        <>
          {/* {Object.keys(projectData).length > 0 && ( */}
          <Modal
            data-bs-keyboard="false"
            onHide={toggleFunction}
            show={isVisible}
            className="modal fade editproject-popup add-user-modal"
            centered={true}
            dialogClassName="common-modal small-modal"
          >
            <ModalHeader closeButton onHide={toggleFunction}>
              <h3 className="modal-title" id="Add_OrganizationLabel">
                Edit Project
              </h3>
            </ModalHeader>
            <ModalBody>
              <Formik
                initialValues={{
                  name: projectData?.name || "",
                  websute_url: projectData?.website_url || "",
                  site_logo: projectData?.website_logo || "",
                  /* fav_icon: projectData?.website_favicon || "", */
                  is_default: projectData?.Users
                    ? projectData?.Users[0].ProjectUser?.is_default
                    : false,
                }}
                validationSchema={Yup.object().shape({
                  name: Yup.string().required("Please enter project name"),
                  websute_url: Yup.string()
                    .nullable()
                    .matches(/^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/, 'Invalid URL')
                    .when(
                      'website_url',
                      (website_url, schema) => {
                        if (website_url !== null && website_url !== undefined && website_url !== '') {
                          return schema.required('Website URL is required');
                        }
                        return schema;
                      }
                    ),
                })}
                onSubmit={handleEditProject}
              >
                {({
                  values,
                  handleChange,
                  handleBlur,
                  touched,
                  errors,
                  isSubmitting,
                  handleSubmit,
                  setFieldValue,
                }) => (
                  <Form>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <div className="form-group">
                            <label className="form-label">
                              Project Short Name*
                            </label>
                            <Fields
                              type="text"
                              placeholder="Project Short Name"
                              className="form-control"
                              touched={touched}
                              errors={errors}
                              onBlur={handleBlur}
                              name="name"
                              value={values.name}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <div className="form-group">
                            <label className="form-label">Website URL</label>
                            <Fields
                              type="text"
                              placeholder="Website URL"
                              className="form-control"
                              touched={touched}
                              errors={errors}
                              onBlur={handleBlur}
                              name="websute_url"
                              value={values.websute_url}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <div className="form-group d-flex">
                            <div className="upload-block ">
                              <label className="form-label">Site Logo</label>
                              <p className="upload-para">(32*32 size)</p>
                              <div className="file-drop-box-sm d-flex align-items-center justify-content-center">
                                <div className="drop-box-content">
                                  {values?.site_logo ? (
                                    <>
                                      <img
                                        src={
                                          typeof values.site_logo === "string"
                                            ? `${process.env
                                              .REACT_APP_CLOUD_FRONT_URL
                                            }projects/${projectId}/${values.site_logo
                                            }?v=${new Date().getTime()}`
                                            : convertFileObjectToObjectURL(
                                              values.site_logo
                                                ? values.site_logo
                                                : ""
                                            )
                                        }
                                        alt="esign-img"
                                        className="esignimg"
                                        height="70px"
                                        width="70px"
                                      />
                                      <div className="remove-upload">
                                        <img
                                          src={closeCircle}
                                          alt=""
                                          className="remove-icon"
                                          onClick={() =>
                                            setFieldValue("site_logo", "")
                                          }
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <input
                                        accept="image/jpeg,image/jpg,image/*"
                                        type="file"
                                        className="drop-file"
                                        onChange={(e) =>
                                          setFieldValue(
                                            "site_logo",
                                            e.target.files[0]
                                          )
                                        }
                                      />
                                      <img
                                        src={uploadIcn}
                                        alt=""
                                        className="icon"
                                      />
                                      <h3 className="w-100">Drag here</h3>
                                      <p className="w-100">Browse file</p>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            {/* <div className="upload-block">
                                                            <label className="form-label">Favicon</label>
                                                            <div className="file-drop-box-sm d-flex align-items-center justify-content-center">
                                                                <div className="drop-box-content">
                                                                    {values?.fav_icon ?
                                                                        <>
                                                                            <embed
                                                                                src={typeof values?.fav_icon === "string" ? values?.fav_icon : convertFileObjectToObjectURL(values.fav_icon ? values.fav_icon : "")}
                                                                                alt="esign-img"
                                                                                className="esignimg"
                                                                                height="32px"
                                                                                width="32px"
                                                                            />
                                                                            <div className="remove-upload">
                                                                                <img
                                                                                    src={closeCircle}
                                                                                    alt=""
                                                                                    className="remove-icon"
                                                                                    onClick={() => setFieldValue("fav_icon", "")}
                                                                                />
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        <div>
                                                                            <input
                                                                                accept='image/jpeg,image/jpg'
                                                                                type="file"
                                                                                className="drop-file"
                                                                                onChange={(e) => setFieldValue("fav_icon", e.target.files[0])}
                                                                            />
                                                                            <img
                                                                                src={uploadIcn}
                                                                                alt=""
                                                                                className="icon"
                                                                            />
                                                                            <h3 className="w-100">Drag here</h3>
                                                                            <p className="w-100">Browse file</p>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <p className="small-note mt-1">
                                                                32*32 size & .icon or .png is recommended
                                                            </p>
                                                        </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-start text-md-end add-user-modal-footer mt-0">
                      {/* <div className='row align-items-center'> */}
                      <div className="col-6">
                        {projectData?.Users && (
                          <div className="form-check text-start footer-check">
                            <Input
                              onChange={() =>
                                setFieldValue("is_default", !values.is_default)
                              }
                              className="form-check-input"
                              type="checkbox"
                              id="is_default"
                              name="is_default"
                              value={values.is_default}
                              defaultChecked={values.is_default}
                              disabled={
                                projectData?.Users[0].ProjectUser?.is_default
                              }
                            />
                            <label className="form-check-label" htmlFor="is_default">
                              Set as Default
                            </label>
                          </div>
                        )}
                      </div>
                      {/* <div className='col-6'> */}
                      <Button
                        disabled={isSubmitting}
                        type="button"
                        className="btn btn-primary-md"
                        onClick={handleSubmit}
                      >
                        Save
                      </Button>
                      {/* </div> */}
                      {/* </div> */}
                    </div>
                  </Form>
                )}
              </Formik>
              {/* <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <div className="form-group">
                                        <label className="form-label">Project Short Name*</label>
                                        <Input
                                            type="text"
                                            placeholder="Project Short Name"
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <div className="form-group">
                                        <label className="form-label">Website URL</label>
                                        <Input
                                            type="text"
                                            placeholder="Website URL"
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <div className="form-group d-flex">
                                        <div className="upload-block ">
                                            <label className="form-label">Site Logo*</label>
                                            <div className="file-drop-box-sm">
                                                <a href="#" className="remove-upload">
                                                    <img
                                                        src={images["close-circle.svg"]}
                                                        alt=""
                                                        className="remove-icon"
                                                    />
                                                </a>
                                                <div className="drop-box-content">
                                                    <Input type="file" className="drop-file" />
                                                    <img src={images['upload-icon.svg']} alt='' className='icon' />
                                                    <h3 className="w-100">Drag here</h3>
                                                    <p className="w-100">Browse file</p>
                                                    <img src={images["owl-icon.svg"]} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="upload-block">
                                            <label className="form-label">Favicon*</label>
                                            <div className="file-drop-box-sm">
                                                <a href="#" className="remove-upload">
                                                    <img
                                                        src={images["close-circle.svg"]}
                                                        alt=""
                                                        className="remove-icon"
                                                    />
                                                </a>
                                                <div className="drop-box-content">
                                                    <input type="file" className="drop-file" />
                                                    <img
                                                        src={images["upload-icon.svg"]}
                                                        alt=""
                                                        className="icon"
                                                    />
                                                    <h3 className="w-100">Drag here</h3>
                                                    <p className="w-100">Browse file</p>
                                                </div>
                                            </div>
                                            <p className="small-note mt-1">
                                                32*32 size & .icon or .png is recommended
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
            </ModalBody>
            {/* <ModalFooter>
                        <Button type="button" className="btn btn-primary-md">
                            Save
                        </Button>
                    </ModalFooter> */}
          </Modal>
          {/* )} */}
        </>
      )}
    </>
  );
};

export default EditProjectModal;
